import React, { useState, useEffect } from "react"
import { Card, CardBody, Container, Row } from "reactstrap"
import axios from "axios"
import { Link } from "react-router-dom"

const Home = () => {
  const token = localStorage.getItem("Token").replace(/"/g, "")
  const [channel, setChannel] = useState()
  const getvideoChannel = async () => {
    try {
      axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/youtube/get-youtube-channels",
        headers: {
          Authorization: token,
        },
      }).then(res => {
        console.log(res.data)
        setChannel(res.data.data)
      })
    } catch (error) {}
  }

  useEffect(() => {
    getvideoChannel()
  }, [token])
  return (
    <Row className="mt-5 py-4">
      <Container>
        <CardBody>
          <Card>
            <ul className="list-group list-group-flush">
              {channel &&
                channel.map((channel, index) => (
                  <Link
                    to={`/video/channel/${channel.id}`}
                    className="list-group-item"
                    key={index}
                  >
                    {channel.channel_name}
                  </Link>
                ))}
            </ul>
          </Card>
        </CardBody>
      </Container>
    </Row>
  )
}

export default Home
